import { defineComponent as _defineComponent } from 'vue'
import {
  useYoutubeIframeAPI,
  YoutubePlayer,
} from '~/lib/composables/useYoutubeIframeAPI'
import mixpanel from 'mixpanel-browser'
import { onMounted, onUnmounted } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  __name: 'TalentOnboardingVideo',
  setup(__props) {

const videoUrl = 'https://www.youtube.com/embed/Eqv8OdoIEzo'

onMounted(() => {
  mixpanel.track('Opened Talent Onboarding Video', {
    VideoUrl: videoUrl,
  })
})

onUnmounted(() => {
  mixpanel.track('Closed Talent Onboarding Video', {
    PlaybackTime: currentTime.value,
    VideoDuration: duration.value,
    VideoUrl: videoUrl,
  })
})

const { currentTime, duration } = useYoutubeIframeAPI('player', {
  onStateChange: (e) => {
    if (e.data === window.YT!.PlayerState.PLAYING) {
      mixpanel.track('Played Talent Onboarding Video', {
        PlaybackTime: e.target.getCurrentTime(),
        VideoDuration: e.target.getDuration(),
        VideoUrl: videoUrl,
      })
    } else if (e.data === window.YT!.PlayerState.PAUSED) {
      mixpanel.track('Paused Talent Onboarding Video', {
        PlaybackTime: e.target.getCurrentTime(),
        VideoDuration: e.target.getDuration(),
        VideoUrl: videoUrl,
      })
    }
  },
})

return { __sfc: true,videoUrl, currentTime, duration }
}

})